import type { CarouselInformativeItemTextProps } from '../carousel-informative'
import { getCustomStyles } from '../utils'

interface TitleProps {
  classSlide: string
  title?: CarouselInformativeItemTextProps
  textAlign?: 'left' | 'center' | 'right'
}

export const Title = ({ classSlide, title, textAlign }: TitleProps) => {
  const customStylesText = getCustomStyles(title?.styles)

  if (!title) {
    return <></>
  }

  return (
    <>
      {title?.text && (
        <h4
          className={`${classSlide}-title`}
          style={{ ...customStylesText, textAlign }}
        >
          {title?.text}
        </h4>
      )}
    </>
  )
}

export default Title
